/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_NowInputs */

const en_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Now`)
};

const ar_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ الآن`)
};

const de_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt beginnen`)
};

const es_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar ahora`)
};

const fr_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer`)
};

const it_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia ora`)
};

const ja_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ始める`)
};

const ko_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 시작하기`)
};

const pt_br_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar agora`)
};

const ru_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать`)
};

const th_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มต้นตอนนี้`)
};

const tr_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Başla`)
};

const zh_cn_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立刻挑战`)
};

const zh_tw_start_now = /** @type {(inputs: Start_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立刻挑戰`)
};

/**
* | output |
* | --- |
* | "Start Now" |
*
* @param {Start_NowInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const start_now = /** @type {((inputs?: Start_NowInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_NowInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_start_now(inputs)
	if (locale === "ar") return ar_start_now(inputs)
	if (locale === "de") return de_start_now(inputs)
	if (locale === "es") return es_start_now(inputs)
	if (locale === "fr") return fr_start_now(inputs)
	if (locale === "it") return it_start_now(inputs)
	if (locale === "ja") return ja_start_now(inputs)
	if (locale === "ko") return ko_start_now(inputs)
	if (locale === "pt_br") return pt_br_start_now(inputs)
	if (locale === "ru") return ru_start_now(inputs)
	if (locale === "th") return th_start_now(inputs)
	if (locale === "tr") return tr_start_now(inputs)
	if (locale === "zh_cn") return zh_cn_start_now(inputs)
	return zh_tw_start_now(inputs)
});